import { NgModule } from '@angular/core';

import {
  BackofficeSearchPipe,
  DateTimeFromNowPipe,
  DaysFromNowPipe,
  HighlightSearchPipe,
  TimeFromNowPipe
} from './pipes.pipe';

@NgModule({
  declarations: [DaysFromNowPipe, TimeFromNowPipe, HighlightSearchPipe, DateTimeFromNowPipe, BackofficeSearchPipe],
  exports: [DaysFromNowPipe, TimeFromNowPipe, HighlightSearchPipe, DateTimeFromNowPipe, BackofficeSearchPipe],
})
export class TmPipesModule { }